module.exports = __webpack_public_path__ + "icon-order-active.png?b67ebc02cdfb4b82fb6a4735ff8d4974";